import React from "react"
import { Grid } from "semantic-ui-react"

const TabNavIntroduction = ({ children }) => (
  <Grid.Row>
    <Grid.Column>{children}</Grid.Column>
  </Grid.Row>
)
TabNavIntroduction.displayName = "TabNavIntroduction"
export default TabNavIntroduction
